/** @format */

import { AnalyticsEvtData } from '../interfaces/attributes-analytics.interface';
import { AttributeOption } from '../interfaces/attributes-v2.interface';
import { inject, Injectable } from '@angular/core';
import { ProductAnalyticsService } from '@shared/data-access/analytics';

@Injectable({
	providedIn: 'root'
})
export class AttributesAnalyticsService {
	private readonly productAnalyticsService = inject(ProductAnalyticsService);

	/**@description Selected Attribute Analytics Event */
	fireAttributeSelectedAnalyticsEvent(selectedAttribute: AttributeOption): void {
		this.productAnalyticsService.triggerAnalyticsEvent('AttributeSelected', {
			Type: `${selectedAttribute.name}`,
			Value: `${selectedAttribute.value}`
		});
	}

	public triggerAnalyticsEvent(eventName: string, eventData?: AnalyticsEvtData[]) {
		this.productAnalyticsService.triggerAnalyticsEvent(eventName, eventData);
	}
}
